export default ({ store }, inject) => {
  inject('openContactsModal', (preselects) =>
    store.dispatch('dynamic-contacts/openContactForm', preselects),
  )
}
